import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import './../App.css';
import XC38Hull from './XC38Hull';
import XC38BowSprit from './XC38BowSprit';
import XC38HullTreatment from './XC38HullTreatment';
import XC38Transom from './XC38Transom';
import XC38Deck from './XC38Deck';
import XC38Sprayhood from './XC38Sprayhood';
import XC38Wheel from './XC38Wheel';
import XC38Mast from './XC38Mast';
import XC38Interior from './XC38Interior';
import XC38Galley from './XC38Galley';
import XC38Fabric from './XC38Fabric';
import XC38OwnersCabin from './XC38OwnersCabin';
import XC38AftCabin from './XC38AftCabin';
import XC38Summary from './XC38Summary';
import XC38BathingPlatform from './XC38BathingPlatform';
import Logo from './XC38-logo.svg';

import hullColor_7032_9010 from '../assets/hullColors/7032_9010.jpg';
import hullColor_7035_9010 from '../assets/hullColors/7035_9010.jpg';
import hullColor_9010_5011 from '../assets/hullColors/9010_5011.jpg';
import hullColor_9010_7011 from '../assets/hullColors/9010_7011.jpg';
import hullColor_9010_7035 from '../assets/hullColors/9010_7035.jpg';

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg';
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg';
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg';
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg';
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg';
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg';
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg';
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg';
import fabric9 from '../assets/fabrics/AlsaceSand.jpg';
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg';

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg';
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg';

import veneer1 from '../assets/interiorColors/nordic_oak.jpg';
import veneer2 from '../assets/interiorColors/teak.jpg';

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg';
import laminate2 from '../assets/interiorColors/walnut.jpg';
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg';

import sprayhood1 from '../assets/sprayhoodColors/without.jpg';
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg';
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg';
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg';
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg';

import ConfiguratorContainer from '../ConfiguratorContainer';
import { withTranslation } from 'react-i18next';

class XC38Container extends ConfiguratorContainer {
    constructor(props) {
        super(props);

        this.logo = Logo;
        this.logoLink = 'https://www.x-yachts.com/en/yachts/xc/xc-38/';

        this.HullColourOptions = [
            { value: 1, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x \'Pebble Grey\' integrated GELCOAT Water Lines (RAL 7032)'), preview: hullColor_9010_7035 },
            { value: 2, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x \'Iron grey\' integrated GELCOAT Water Lines (RAL 7011)'), preview: hullColor_9010_7011 },
            { value: 3, label: this.props.t('Pure White'), description: this.props.t('(RAL 9010) & 3 x \'Steel blue\' integrated GELCOAT Water Lines (RAL 5011)'), preview: hullColor_9010_5011 },
            { value: 4, label: this.props.t('Pebble Grey'), description: this.props.t('(RAL 7032) & 3 x white integrated GELCOAT Water Lines (RAL 9010)'), preview: hullColor_7032_9010 },
            { value: 5, label: this.props.t('Light Grey'), description: this.props.t('(RAL 7035) & 3 x white integrated GELCOAT Water Lines (RAL 9010)'), preview: hullColor_7035_9010 }
        ];

        this.BowSpritOptions = [
            { value: 2, label: this.props.t('Standard'), description: this.props.t('(with teak)') }
        ];

        this.HullTreatmentOptions = [
            { value: 1, label: this.props.t('White') },
            { value: 3, label: this.props.t('Copper (optional)') }
        ];

        this.DeckOptions = [
            { value: 1, label: this.props.t('Genuine teak with black caulkings') },
            { value: 2, label: this.props.t('Flexiteek with grey stripes') }
        ];

        this.SprayhoodTypeOptions = [
            { value: 1, label: this.props.t('Standard') },
            { value: 2, label: this.props.t('Framed') }
        ];

        this.SprayhoodOptions = [
            { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
            { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
            { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
            { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
            { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
        ];

        this.BoomCoverOptions = this.SprayhoodOptions;

        this.WheelOptions = [
            { value: 1, label: this.props.t('Steel wheel') },
            { value: 2, label: this.props.t('Composite wheel black') },
            { value: 3, label: this.props.t('Composite wheel white') }
        ];

        this.MastAndBoomOptions = [
            { value: 1, label: this.props.t('Standard silver anodized aluminum') },
            { value: 2, label: this.props.t('White painted (or foiled) aluminium mast') },
            { value: 3, label: this.props.t('Black painted (or foiled) aluminium mast') }
        ];

        this.VeneerOptions = [
            { value: 1, label: this.props.t('Nordic oak (standard)'), thumbnail: veneer1 },
            { value: 2, label: this.props.t('Modern teak (optional)'), thumbnail: veneer2 }
        ];

        this.FloorboardOptions = [
            { value: 1, label: this.props.t('Teak laminate (standard)'), thumbnail: laminate1 },
            { value: 2, label: this.props.t('Walnut laminate (optional)'), thumbnail: laminate2 },
            { value: 3, label: this.props.t('Teak with inlay stripes / holly (optional)'), thumbnail: laminate3 }
        ];

        this.WorktopOptions = [
            { value: 1, label: this.props.t('Worktop in Camoan white Corian'), thumbnail: galley1 },
            { value: 2, label: this.props.t('Worktop in black quartz Corian'), thumbnail: galley2 }
        ];

        this.FabricOptions = [
            { value: 1, label: this.props.t('Just Fleckless – 01 Nature'), thumbnail: fabric1 },
            { value: 2, label: this.props.t('Just Fleckless – 05 Camel'), thumbnail: fabric2 },
            { value: 3, label: this.props.t('Just Fleckless – 10 Navy'), thumbnail: fabric3 },
            { value: 4, label: this.props.t('Just Fleckless – 403 Bambus'), thumbnail: fabric4 },
            { value: 5, label: this.props.t('Just Fleckless – 710 Moon Grey'), thumbnail: fabric5 },
            { value: 6, label: this.props.t('Just Fleckless – 750 Olive Grey'), thumbnail: fabric6 },
            { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
            { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
            { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
            { value: 10, label: this.props.t('Nubilux 709 Argent'), thumbnail: fabric10 }
        ];

        this.HandrailOptions = [
            { value: 1, label: this.props.t('Nordic oak'), thumbnail: veneer1 },
            { value: 2, label: this.props.t('Teak'), thumbnail: veneer2 }
        ];

        this.LayoutOptions = [
            { value: 1, label: this.props.t('Shelf') },
            { value: 2, label: this.props.t('Seaberths') }
        ];


        this.state = Object.assign(this.state, {
            boat: 'xc38',
            exterior: {
                HullColour: this.HullColourOptions[0],
                Bowsprit: this.BowSpritOptions[0],
                HullTreatment: this.HullTreatmentOptions[0],
                Deck: this.DeckOptions[0],
                TeakOnSideDecks: { value: 1, label: 'false' },
                TeakOnCoachroof: { value: 1, label: 'false' },
                SprayHoodType: this.SprayhoodTypeOptions[0],
                SprayHood: this.SprayhoodOptions[0],
                Wheel: this.WheelOptions[0],
                MastAndBoom: this.MastAndBoomOptions[0],
                BoomCover: this.BoomCoverOptions[0]
            },
            transom: {
                Name: {
                    verticalOffset: 0,
                    color: this.colorOptions[10],
                    value: 'My yacht',
                    font: this.fontOptions[0],
                    size: this.sizeOptions[2],
                    horizontalOffset: 0
                },
                Port: {
                    verticalOffset: 350,
                    color: this.colorOptions[10],
                    value: 'Port',
                    font: this.fontOptions[0],
                    size: this.sizeOptions[1],
                    horizontalOffset: 0
                }
            },
            interior: {
                Veneer:  this.VeneerOptions[0],
                Floorboard: this.FloorboardOptions[0],
                Worktop: this.WorktopOptions[0],
                Fabric: this.FabricOptions[0],
                Handrail: this.HandrailOptions[0],
                PleatedBlinds: { value: 1, label: 'false' },
                AftCabinLayout: this.LayoutOptions[0],
                FabricCabins: this.FabricOptions[0],
                Mast: this.MastAndBoomOptions[0]
            }
        });

        this.steps = [
            { name: this.props.t('Hull colourways'), url: '/xc38/hull' },
            { name: this.props.t('Bowsprit'), url: '/xc38/bowsprit' },
            { name: this.props.t('Hull treatment'), url: '/xc38/hulltreatment' },
            { name: this.props.t('Deck'), url: '/xc38/deck' },
            { name: this.props.t('Bathing platform'), url: '/xc38/bathingplatform' },
            { name: this.props.t('Boat name'), url: '/xc38/transom' },
            { name: this.props.t('Mast and boom'), url: '/xc38/mast' },
            { name: this.props.t('Wheels'), url: '/xc38/wheel' },
            { name: this.props.t('Sprayhood & Boom Cover'), url: '/xc38/sprayhood' },

            { name: this.props.t('Interior surfaces'), url: '/xc38/surfaces' },
            { name: this.props.t('Interior Fabric'), url: '/xc38/fabric' },
            { name: this.props.t('Galley'), url: '/xc38/galley' },
            { name: this.props.t('Owner\'s cabin'), url: '/xc38/ownerscabin' },
            { name: this.props.t('Aft cabins'), url: '/xc38/aftcabin' },
            
            { name: this.props.t('Summary'), url: '/xc38/summary' }
        ];

        this.handleHullConfigurationChange = this.handleHullConfigurationChange.bind(this);
    }

    handleHullConfigurationChange(newConfiguration) {
        let transom = this.state.transom;
        switch (newConfiguration.HullColour.value) {
            case 1:
                transom.Name.color = this.colorOptions[10];
                transom.Port.color = this.colorOptions[10];
                break;
            case 2:
                transom.Name.color = this.colorOptions[3];
                transom.Port.color = this.colorOptions[3];
                break;
            case 3:
                transom.Name.color = this.colorOptions[4];
                transom.Port.color = this.colorOptions[4];
                break;
            case 4:
            case 5:
            case 6:
                transom.Name.color = this.colorOptions[1];
                transom.Port.color = this.colorOptions[1];
                break;
            default:
                break;

        }


        super.handleTransomChange(transom);
        super.handleExteriorConfigurationChange(newConfiguration);
    }

    handleExteriorConfigurationChange(newConfiguration) {
        let interior = this.state.interior;
        interior.Mast = newConfiguration.MastAndBoom;

        super.handleInteriorConfigurationChange(interior);
        super.handleExteriorConfigurationChange(newConfiguration);
    }

    generateCode() {
        let data = [];
        data.push("xc38");

        data.push([]);
        let exterior = this.state.exterior;
        for (const key in exterior) {
            if (exterior.hasOwnProperty(key)) {
                let element = exterior[key].value;
                data[data.length - 1].push(element);
            }
        }

        data.push([]);
        data[data.length - 1].push([]);
        data[data.length - 1].push([]);

        let transom = this.state.transom;
        data[data.length - 1][0].push(transom.Name.value);
        data[data.length - 1][0].push(transom.Name.font.value);
        data[data.length - 1][0].push(transom.Name.size.value);
        data[data.length - 1][0].push(transom.Name.color.value);
        data[data.length - 1][0].push(transom.Name.horizontalOffset);
        data[data.length - 1][0].push(transom.Name.verticalOffset);

        data[data.length - 1][1].push(transom.Port.value);
        data[data.length - 1][1].push(transom.Port.font.value);
        data[data.length - 1][1].push(transom.Port.size.value);
        data[data.length - 1][1].push(transom.Port.color.value);
        data[data.length - 1][1].push(transom.Port.horizontalOffset);
        data[data.length - 1][1].push(transom.Port.verticalOffset);

        data.push([]);
        let interior = this.state.interior;
        for (const key in interior) {
            if (interior.hasOwnProperty(key)) {
                let element = interior[key].value;
                data[data.length - 1].push(element);
            }
        }
        
        var json = JSON.stringify(data);
        return btoa(json);
    }

    parseCode(code) {
        let json = JSON.parse(atob(code));

        if (json[0] !== 'xc38') {
            return;
        }

        let exterior = this.state.exterior;
        exterior.HullColour = this.HullColourOptions.find(v => v.value === json[1][0]) || this.HullColourOptions[0];
        exterior.Bowsprit = this.BowSpritOptions.find(v => v.value === json[1][1]) || this.BowSpritOptions[0];
        exterior.HullTreatment = this.HullTreatmentOptions.find(v => v.value === json[1][2]) || this.HullTreatmentOptions[0];
        exterior.Deck = this.DeckOptions.find(v => v.value === json[1][3]) || this.DeckOptions[0];
        exterior.TeakOnSideDecks = { value: +json[1][4] || 1, label: '' };
        exterior.TeakOnCoachroof = { value: +json[1][5] || 1, label: '' };
        exterior.SprayHoodType = this.SprayhoodTypeOptions.find(v => v.value === json[1][6]) || this.SprayhoodTypeOptions[0];
        exterior.SprayHood = this.SprayhoodOptions.find(v => v.value === json[1][7]) || this.SprayhoodOptions[0];
        exterior.Wheel = this.WheelOptions.find(v => v.value === json[1][8]) || this.WheelOptions[0];
        exterior.MastAndBoom = this.MastAndBoomOptions.find(v => v.value === json[1][9]) || this.MastAndBoomOptions[0];
        exterior.BoomCover = this.BoomCoverOptions.find(v => v.value === json[1][10]) || this.BoomCoverOptions[0];

        let transom = this.state.transom;
        transom.Name.value = json[2][0][0] || '';
        transom.Name.font = this.fontOptions.find(v => v.value === json[2][0][1]) || this.fontOptions[0];
        transom.Name.size = this.sizeOptions.find(v => v.value === json[2][0][2]) || this.sizeOptions[0];
        transom.Name.color = this.colorOptions.find(v => v.value === json[2][0][3]) || this.colorOptions[0];
        transom.Name.horizontalOffset = +json[2][0][4] || 1;
        transom.Name.verticalOffset = +json[2][0][5] || 1;

        transom.Port.value = json[2][1][0] || '';
        transom.Port.font = this.fontOptions.find(v => v.value === json[2][1][1]) || this.fontOptions[0];
        transom.Port.size = this.sizeOptions.find(v => v.value === json[2][1][2]) || this.sizeOptions[0];
        transom.Port.color = this.colorOptions.find(v => v.value === json[2][1][3]) || this.colorOptions[0];
        transom.Port.horizontalOffset = +json[2][1][4] || 1;
        transom.Port.verticalOffset = +json[2][1][5] || 1;
        
        let interior = this.state.interior;
        interior.Veneer = this.VeneerOptions.find(v => v.value === json[3][0]) || this.VeneerOptions[0];
        interior.Floorboard = this.FloorboardOptions.find(v => v.value === json[3][1]) || this.FloorboardOptions[0];
        interior.Worktop = this.WorktopOptions.find(v => v.value === json[3][2]) || this.WorktopOptions[0];
        interior.Fabric = this.FabricOptions.find(v => v.value === json[3][3]) || this.FabricOptions[0];
        interior.Handrail = this.HandrailOptions.find(v => v.value === json[3][4]) || this.HandrailOptions[0];
        interior.PleatedBlinds = { value: +json[3][5] || 1, label: '' };
        interior.AftCabinLayout = this.LayoutOptions.find(v => v.value === json[3][6]) || this.LayoutOptions[0];
        interior.FabricCabins = this.FabricOptions.find(v => v.value === json[3][7]) || this.FabricOptions[0];
        interior.Mast = exterior.MastAndBoom;

        
        
        this.setState(this.state);
    }


    renderSteps() {
        return (
            <Switch location={this.props.location}>
                <Route exact path="/xc38" render={() => <Redirect to="/xc38/hull" />} />

                <Route path="/xc38/hull" render={(props) => <XC38Hull {...props} onChange={this.handleHullConfigurationChange} onCodeSubmitted={this.parseCode} configuration={this.state.exterior} transom={this.state.transom} hullColourOptions={this.HullColourOptions} />} />
                <Route path="/xc38/bowsprit" render={(props) => <XC38BowSprit {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} bowSpritOptions={this.BowSpritOptions} />} />
                <Route path="/xc38/hulltreatment" render={(props) => <XC38HullTreatment {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} hullTreatmentOptions={this.HullTreatmentOptions} />} />
                <Route path="/xc38/transom" render={(props) => <XC38Transom {...props} onChange={this.handleTransomChange} configuration={this.state.exterior} transom={this.state.transom} fontOptions={this.fontOptions} sizeOptions={this.sizeOptions} colorOptions={this.colorOptions} />} />
                <Route path="/xc38/deck" render={(props) => <XC38Deck {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} deckOptions={this.DeckOptions} />} />
                <Route path="/xc38/bathingplatform" render={(props) => <XC38BathingPlatform {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} />} />
                <Route path="/xc38/sprayhood" render={(props) => <XC38Sprayhood {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} sprayhoodTypeOptions={this.SprayhoodTypeOptions} sprayhoodOptions={this.SprayhoodOptions} boomCoverOptions={this.BoomCoverOptions} />} />
                <Route path="/xc38/wheel" render={(props) => <XC38Wheel {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} wheelOptions={this.WheelOptions} />} />
                <Route path="/xc38/mast" render={(props) => <XC38Mast {...props} onChange={this.handleExteriorConfigurationChange} configuration={this.state.exterior} transom={this.state.transom} mastAndBoomOptions={this.MastAndBoomOptions} />} />

                <Route path="/xc38/surfaces" render={(props) => <XC38Interior {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} veneerOptions={this.VeneerOptions} floorboardOptions={this.FloorboardOptions} handrailOptions={this.HandrailOptions} />} />
                <Route path="/xc38/fabric" render={(props) => <XC38Fabric {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} fabricOptions={this.FabricOptions} />} />
                <Route path="/xc38/galley" render={(props) => <XC38Galley {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} worktopOptions={this.WorktopOptions} layoutOptions={this.LayoutOptions} />} />
                <Route path="/xc38/aftcabin" render={(props) => <XC38AftCabin {...props} onChange={this.handleInteriorConfigurationChange} configuration={this.state.interior} aftCabinOptions={this.LayoutOptions} />} />
                <Route path="/xc38/ownerscabin" render={(props) => <XC38OwnersCabin {...props} onChange={this.handleInteriorConfigurationChange} fabricOptions={this.FabricOptions} configuration={this.state.interior} />} />

                <Route path="/xc38/summary" render={(props) => <XC38Summary {...props} country={this.state.country} countries={this.state.countries} code={this.generateCode()} configuration={{ exterior: this.state.exterior, interior: this.state.interior, transom: this.state.transom }} />} />
            </Switch>
        );
    }
}

export default withTranslation()(XC38Container);


// WEBPACK FOOTER //
// ./src/XC38/XC38Container.js